import {FormControl, FormGroup} from "@angular/forms";

export class SiteNameStructureModel extends FormGroup {
  constructor() {
    super({
      siteNameStructure: new FormControl(),
    });
  }

  parseProjectJson(project?: any) {
    this.setValue({
      siteNameStructure: project.siteNameStructure || "",
    });
  }
}
